import { CONDITION_TYPE, VALIDATE } from '@cognitiv/cicada-ui';
import { ProjectFormState } from 'ducks/types/common-types';

export const default_state: ProjectFormState = {
  project_name: '',
};

export const validation = {
  project_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Project name is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
};
